import { all } from "redux-saga/effects";
import { watchLoginRequest, watchLogoutRequest } from "../pages/login/saga";
import {
  watchSignupRequest,
  watchSpecilityRequest,
} from "../pages/signup/saga";
import watchPasswordRecoveryRequest from "../pages/password-recovery/saga";
import watchPasswordResetRequest from "../pages/password-reset/saga";
import watchPasswordChangeRequest from "../pages/password-change/saga";
import watchCompleteSubscriptionRequest from "../pages/complete-subscription/saga";
import watchGetUserRequest from "../pages/admin/saga";
import watchGetPlaylistsRequest from "../pages/playlists/saga";
import watchGetSubcriptionRequest from "../pages/quiz/saga";
import watchAddPlaylistRequest from "../pages/playlists/add/saga";
import watchDeletePlaylistRequest from "../pages/playlists/delete/saga";
import watchUpdatePlaylistRequest from "../pages/playlists/update/saga";
import {
  watchSaveCardRequest,
  watchUnsubcriptionRequest,
} from "../pages/subscription/saga";
import watchEmailVarificationRequest from "../pages/confirmemail/saga";
import {
  watchGetPlanningsRequest,
  watchAddPlanningRequest,
  watchUpdatePlanningRequest,
  watchDeletePlanningRequest,
} from "../pages/plannings/sagas";
import {
  watchUserProfileUpdateRequest,
  watchUserProfileEmailUpdateRequest,
  watchSpecilityByIdRequest,
} from "../pages/userprofile/saga";
import watchGetVideosRequest from "../pages/playlists/form/videos/saga";
import {
  watchGetCategoriesRequest,
  watchGetCategoryVideosRequest,
} from "../pages/playlists/form/videos/video-chooser/saga";
import {
  watchGetCategoriesForPatientRequest,
  watchGetCategoryVideosForPatientRequest,
  watchPatientRequest,
  watchGetPlaylistVideos,
  watchGetLngLatMap,
} from "../pages/patientplaylist/saga";
import watchGetInvoicesRequest from "../pages/userinvoices/saga";
import watchgetQrcodeVisiteRequest from "../pages/patientplaylist/saga";
// import watchgetNbVisiteRequest from '../pages/admin/stats/saga';
import {
  watchGetTop3CategoryVisitedRequest,
  watchgetNbVisiteRequest,
  watchResetStatsMonthlyRequest,
  watchgetArrayVisiteYearsRequest,
} from "../pages/admin/stats/saga";

export default function* sagas() {
  yield all([
    watchSpecilityRequest(),
    watchSaveCardRequest(),
    watchUnsubcriptionRequest(),
    watchLoginRequest(),
    watchUserProfileUpdateRequest(),
    watchSpecilityByIdRequest(),
    watchUserProfileEmailUpdateRequest(),
    watchSignupRequest(),
    watchEmailVarificationRequest(),
    watchPasswordChangeRequest(),
    watchLogoutRequest(),
    watchPasswordRecoveryRequest(),
    watchPasswordResetRequest(),
    watchCompleteSubscriptionRequest(),
    watchGetUserRequest(),
    watchGetPlaylistsRequest(),
    watchPatientRequest(),
    watchGetSubcriptionRequest(),
    watchAddPlaylistRequest(),
    watchDeletePlaylistRequest(),
    watchUpdatePlaylistRequest(),
    watchGetPlanningsRequest(),
    watchAddPlanningRequest(),
    watchUpdatePlanningRequest(),
    watchDeletePlanningRequest(),
    watchGetVideosRequest(),
    watchGetCategoriesRequest(),
    watchGetCategoryVideosRequest(),
    watchGetCategoriesForPatientRequest(),
    watchGetCategoryVideosForPatientRequest(),
    watchGetInvoicesRequest(),
    watchGetPlaylistVideos(),
    watchGetLngLatMap(),
    watchgetQrcodeVisiteRequest(),
    watchgetNbVisiteRequest(),
    watchGetTop3CategoryVisitedRequest(),
    watchResetStatsMonthlyRequest(),
    watchgetArrayVisiteYearsRequest(),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas.js